import React from 'react';
import EarnText from '../components/About/Earn/EarnText';
import FAQAccordion from '../components/About/FAQAccordion';
import Footer from '../components/General/Footer';
import Head from '../components/Header/Head';
import Header from '../components/Header/Header';
import withApollo from '../lib/withApollo';

const EarnPage = () => {
  return (
    <>
      <Head
        title="Earn Cryptocurrency for Travel Blogging"
        description="Start your own travel blog and get paid to travel around the world. On TravelFeed you can earn cryptocurrency for travel blogging. Find out how!"
      />
      <Header active="earn" subheader="Earn Crypto" />
      <div className="container">
        <EarnText />
        <FAQAccordion />
        <div className="pt-5 pb-2">
          <em>
            Cryptocurrency is distributed by the blockchain rewards pool
            algorithm of third-party blockchains. There is no entitlement to be
            rewarded and TravelFeed is not responsible for any events or
            transactions happening on third-party blockchains, especially not
            those that can lead to a loss of funds. We advise you to familiarize
            yourself with regulations concerning cryptocurrency and
            cryptocurrency income in your country.
          </em>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default withApollo(EarnPage);
